import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { UserState } from './types'

export const state: UserState = {
  requestResetPasswordError: false
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
